import classNames from 'classnames';
import { isEmpty } from 'lodash-es';

import Icon from 'components/ui/icon';

import './smallBannerCard.scss';

type ButtonProps = {
  type: 'div' | 'a';
  buttonLink: string;
  buttonTitle: string;
};

const SmallBannerCardButton: React.FC<ButtonProps> = ({
  type,
  buttonLink,
  buttonTitle,
}) => {
  const CustomTag = type;

  return (
    <CustomTag className='small-banner-card__button' href={buttonLink}>
      {buttonTitle}
      <span className='small-banner-card__button-arrow'>
        <Icon name='im-Arrow-right-Option-2' size={10} />
      </span>
    </CustomTag>
  );
};

type Props = {
  title: string;
  text: string;
  buttonTitle: string;
  buttonLink: string;
  customClass?: string;
  disabled?: boolean;
  image?: string;
  preview?: boolean;
  loading?: boolean;
};

export const SmallBannerCard: React.FC<Props> = ({
  title,
  text,
  buttonTitle,
  buttonLink,
  customClass,
  disabled,
  image,
  preview,
}) => {
  return (
    <div
      className={classNames('card small-banner-card', customClass, {
        'small-banner-card_disabled': disabled === true,
        'small-banner-card_background': isEmpty(image) === false,
        'small-banner-card_preview': preview === true,
      })}
      style={{
        backgroundImage: image ? `url(${image})` : 'unset',
      }}>
      {title ? <h4 className='small-banner-card__title'>{title}</h4> : null}
      {text ? <div className='small-banner-card__text'>{text}</div> : null}
      <SmallBannerCardButton
        type={preview === true ? 'div' : 'a'}
        buttonTitle={buttonTitle}
        buttonLink={buttonLink}
      />
    </div>
  );
};
